import React, {useEffect, useRef} from 'react';
import {scrollRoot} from './useListing';

export default function LoadMore({offset, busy, refreshing, error, more}) {
  const sentinel = useRef(null);
  const supported = typeof window.IntersectionObserver === 'function';
  useEffect(() => {
    if (!supported || offset == null || busy || refreshing || error) return undefined;
    const observer = new window.IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) more();
    }, {root: scrollRoot(sentinel.current), rootMargin: '0px 0px 480px 0px'});
    observer.observe(sentinel.current);
    return () => observer.disconnect();
  }, [supported, offset, busy, refreshing, error, more]);
  if (offset == null && !error) return null;
  return <div ref={sentinel} className="st-load-more">
    {error ? <><span role="alert">{error}</span><button onClick={more} disabled={busy}>Повторить загрузку</button></>
      : busy ? <span role="status"><i className="st-spinner" aria-hidden="true"/>Загружаем следующие файлы…</span>
      : !supported ? <button onClick={more} disabled={refreshing}>Загрузить следующие файлы</button>
      : <span className="st-muted">Следующие файлы загрузятся при прокрутке</span>}
  </div>;
}
